module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "header": "活动信息"
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面图片",
      "prop": "icon"
    }
  }, [_c('image-upload', {
    model: {
      value: (_vm.formData.icon),
      callback: function($$v) {
        _vm.$set(_vm.formData, "icon", $$v)
      },
      expression: "formData.icon"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开始日期",
      "prop": "startDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "clearable": false,
      "editable": false,
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结束日期",
      "prop": "endDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "clearable": false,
      "editable": false,
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动正文",
      "prop": "content"
    }
  }, [_c('ckeditor', {
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接地址",
      "prop": "url"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布日期",
      "prop": "publishDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "clearable": false,
      "editable": false,
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.formData.publishDate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "publishDate", $$v)
      },
      expression: "formData.publishDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(false)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm(true)
      }
    }
  }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('ActivityView', {
    attrs: {
      "activity": _vm.formData
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bacb83a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/activity/Edit.vue
// module id = 1178
// module chunks = 2